import React from "react";
// import ReactDOMServer from "react-dom/server";
import contextProvider from "../../../contextProvider";
import { Link } from "react-router-dom";
import MarkerClusterGroup from "react-leaflet-markercluster";
import isValidCoordinates from "is-valid-coordinates";
// import ReactSvgPieChart from "react-svg-piechart";

import { Map, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";
// import MapCacheLayer from "../../Elements/MapCacheLayer";

import ReactOButton from "../../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../../_L1_components/Elements/ReactOActionBar";
import Section from "../../../_L1_components/Layout/Section";
import Panel from "../../../_L1_components/Layout/Panel";
import { Row, Col } from "reactstrap";
import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOCollapse from "../../../_L1_components/Elements/ReactOCollapse";

// ICON FOR MARKER
const iconSettings = {
  iconProbeGreen: {
    mapIconUrl: `<svg width="30px" height="40px" viewBox="0 0 179 263" version="1.1">
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		<g id="WiFiProbe_marker_success" fillRule="nonzero">
		<path d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z" id="Combined-Shape" fill="{mapIconColor}"></path>
		<circle id="Oval" fill="{mapIconColorInner}" cx="90" cy="90" r="69"></circle>
		<g id="Group-2" transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)" fill="{mapIconColor}">
			<path d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z" id="Rectangle-2"></path>
			<rect id="Rectangle-4" x="9" y="1.84741111e-13" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-5" x="27" y="2.84217094e-14" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
		</g>
		</g>
		</g>
		</svg>`,
    mapIconColor: "#28A745",
    mapIconColorInner: "#FFFFFF",
  },
  iconProbeRed: {
    mapIconUrl: `<svg width="30px" height="40px" viewBox="0 0 179 263" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<defs></defs>
		<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g id="WiFiProbe_marker_error" fill-rule="nonzero">
		<path d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z" id="Combined-Shape" fill="{mapIconColor}"></path>
		<circle id="Oval" fill="{mapIconColorInner}" cx="90" cy="90" r="69"></circle>
		<g id="Group-2" transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)" fill="{mapIconColor}">
			<path d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z" id="Rectangle-2"></path>
			<rect id="Rectangle-4" x="9" y="1.84741111e-13" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-5" x="27" y="2.84217094e-14" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
		</g>
		</g>
		</g>
		</svg>`,
    mapIconColor: "#DC3545",
    mapIconColorInner: "#FFFFFF",
  },
  iconProbeAnomalies: {
    mapIconUrl: `<svg width="30px" height="40px" viewBox="0 0 179 263" version="1.1">
		<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		<g id="WiFiProbe_marker_success" fillRule="nonzero">
		<path d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z" id="Combined-Shape" fill="{mapIconColor2}"></path>
		<circle id="Oval" fill="{mapIconColorInner}" cx="90" cy="90" r="69"></circle>
		<g id="Group-2" transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)" fill="{mapIconColor}">
			<path d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z" id="Rectangle-2"></path>
			<rect id="Rectangle-4" x="9" y="1.84741111e-13" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-5" x="27" y="2.84217094e-14" width="18" height="23" rx="6"></rect>
			<rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
		</g>
		</g>
		</g>
		</svg>
		`,
    mapIconColor: "#DC3545",
    mapIconColor2: "#28A745",
    mapIconColorInner: "#FFFFFF",
  },
  iconProbeWarning: {
    mapIconUrl: `<svg width="30px" height="40px" viewBox="0 0 179 263" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
		<defs></defs>
		<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<g id="WiFiProbe_marker_warning" fill-rule="nonzero">
			<path d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z" id="Combined-Shape" fill="{mapIconColor}"></path>
			<circle id="Oval" fill="{mapIconColorInner}" cx="90" cy="90" r="69"></circle>
			<g id="Group-2" transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)" fill="{mapIconColor}">
				<path d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z" id="Rectangle-2"></path>
				<rect id="Rectangle-4" x="9" y="1.84741111e-13" width="18" height="23" rx="6"></rect>
				<rect id="Rectangle-5" x="27" y="2.84217094e-14" width="18" height="23" rx="6"></rect>
				<rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
			</g>
		</g>
		</g>
		</svg>`,
    mapIconColor: "#ffc107",
    mapIconColorInner: "#FFFFFF",
  },
};

// ICON FOR LEGEND
const iconProbeGreen = (
  <svg width="21px" height="30.90px" viewBox="0 0 179 263" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="WiFiProbe_marker_success" fillRule="nonzero">
        <path
          d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z"
          id="Combined-Shape"
          fill="#28A745"
        ></path>
        <circle id="Oval" fill="#FFFFFF" cx="90" cy="90" r="69"></circle>
        <g
          id="Group-2"
          transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)"
          fill="#28A745"
        >
          <path
            d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z"
            id="Rectangle-2"
          ></path>
          <rect
            id="Rectangle-4"
            x="9"
            y="1.84741111e-13"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect
            id="Rectangle-5"
            x="27"
            y="2.84217094e-14"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
        </g>
      </g>
    </g>
  </svg>
);

const iconProbeRed = (
  <svg width="21px" height="30.90px" viewBox="0 0 179 263" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="WiFiProbe_marker_error" fillRule="nonzero">
        <path
          d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z"
          id="Combined-Shape"
          fill="#DC3545"
        ></path>
        <circle id="Oval" fill="#FFFFFF" cx="90" cy="90" r="69"></circle>
        <g
          id="Group-2"
          transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)"
          fill="#DC3545"
        >
          <path
            d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z"
            id="Rectangle-2"
          ></path>
          <rect
            id="Rectangle-4"
            x="9"
            y="1.84741111e-13"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect
            id="Rectangle-5"
            x="27"
            y="2.84217094e-14"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
        </g>
      </g>
    </g>
  </svg>
);

const iconProbeWarning = (
  <svg width="21px" height="30.9px" viewBox="0 0 179 263" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="WiFiProbe_marker_warning" fillRule="nonzero">
        <path
          d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z"
          id="Combined-Shape"
          fill="#ffc107"
        ></path>
        <circle id="Oval" fill="#FFFFFF" cx="90" cy="90" r="69"></circle>
        <g
          id="Group-2"
          transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)"
          fill="#ffc107"
        >
          <path
            d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z"
            id="Rectangle-2"
          ></path>
          <rect
            id="Rectangle-4"
            x="9"
            y="1.84741111e-13"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect
            id="Rectangle-5"
            x="27"
            y="2.84217094e-14"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
        </g>
      </g>
    </g>
  </svg>
);

const iconProbeAnomalies = (
  <svg width="21px" height="30.90px" viewBox="0 0 179 263" version="1.1">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="WiFiProbe_marker_success" fillRule="nonzero">
        <path
          d="M89.5,262.335663 C132.488487,199.4714 179,139.070384 179,89.640899 C179,40.211414 138.929485,0.1408991 89.5,0.1408991 C40.070515,0.1408991 0,40.211414 0,89.640899 C0,139.070384 51.156615,201.728527 89.5,262.335663 Z"
          id="Combined-Shape"
          fill="#28A745"
        ></path>
        <circle id="Oval" fill="#FFF" cx="90" cy="90" r="69"></circle>
        <g
          id="Group-2"
          transform="translate(89.313163, 89.823112) rotate(28.000000) translate(-89.313163, -89.823112) translate(62.313163, 39.823112)"
          fill="#DC3545"
        >
          <path
            d="M2.97810219,54.1219471 L2.97810219,94.2124855 C2.97810219,97.4050131 5.55549772,100 8.73487626,100 L45.2432259,100 C48.4181342,100 51,97.4088417 51,94.2124855 L51,28.7875148 C51,25.5949868 48.4226044,23 45.2432259,23 L8.73487626,23 C5.55996798,23 2.97810219,25.5911586 2.97810219,28.7875148 L2.97810219,29.4385485 C1.2822289,29.7332218 0,31.2171166 0,33.0033455 L0,50.5576301 C0,52.3372856 1.28640103,53.8255491 2.97810219,54.1219471 Z"
            id="Rectangle-2"
          ></path>
          <rect
            id="Rectangle-4"
            x="9"
            y="1.84741111e-13"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect
            id="Rectangle-5"
            x="27"
            y="2.84217094e-14"
            width="18"
            height="23"
            rx="6"
          ></rect>
          <rect id="Rectangle-6" x="30" y="35" width="24" height="18"></rect>
        </g>
      </g>
    </g>
  </svg>
);

class Dashboard extends _ReactOBaseComponent {
  constructor(props) {
    let initState = {
      // loading: true,
      locations_loading: true,
      loading: true,
      data: null,
      locations_data: null,
      zoom: 11,
      currentPos: null,
      // center: [45.027072, 7.636997],
      onFocus: false,
      selectedMarker: null,
      selectedItem: null,
      initFocus: null,
    };
    super(props, initState);
    this.mapRef = React.createRef();
    this.clusterRef = React.createRef();
    this.markerRef = React.createRef();
    this.apiStore = null;
    this.actionsShelf = null;
    this._viewMode = "card";
    this._circleMap = null;
    // this.handleClick = this.handleClick.bind(this);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    this.loadProbesLocation();
  }

  onComponentWillUpdate() {
    this.setState({
      boundsOptions: null,
    });
  }

  loadProbesLocation(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("probes_location", {
          ___onSuccess: (status, data) => {
            // this._bounds = []
            // Object.keys(data).map((_C_probeId, _C_idx) => { this._bounds.push([data[_C_probeId].location.data.lat, data[_C_probeId].location.data.long]) })
            this.formatMarkers(data);
            this.setState(
              {
                locations_data: data,
                locations_loading: false,
                controlMap: true,
                zoomControl: true,
                boundsOptions: { padding: [50, 50] },
              },
              cb ? cb : null
            );
          },
        });
      }
    );
  }

  formatMarkers(data) {
    if (Object.keys(data).length > 0) {
      const markersMap = [];
      const markersError = [];
      this._bounds = [];
      Object.keys(data)
        // .filter((value)=>{return data[value].location != undefined})
        .filter((value) => {
          return (
            data[value].status != "KO" &&
            data[value].diag.probe_status != "not_deployed" &&
            isValidCoordinates(
              data[value].location.data.lat,
              data[value].location.data.long
            )
          );
        })
        .forEach((_C_probeId, _C_idx) => {
          let markerIcon = L.divIcon({
            className: "",
            html: L.Util.template(
              iconSettings.iconProbeGreen.mapIconUrl,
              iconSettings.iconProbeGreen
            ),
            iconAnchor: [15, 40],
            iconSize: [30, 40],
          });

          this._bounds.push([
            data[_C_probeId].location.data.lat,
            data[_C_probeId].location.data.long,
          ]);

          if (
            data[_C_probeId].diag.sync_status == 0 &&
            data[_C_probeId].diag.probe_status == "deployed"
          ) {
            markerIcon = L.divIcon({
              className: "",
              html: L.Util.template(
                iconSettings.iconProbeRed.mapIconUrl,
                iconSettings.iconProbeRed
              ),
              iconAnchor: [15, 40],
              iconSize: [30, 40],
            });
          }

          if (
            data[_C_probeId].diag.measures.length > 0 &&
            data[_C_probeId].diag.probe_status == "deployed"
          ) {
            let _anomaliesArray = data[_C_probeId].diag.measures.filter((value) => {
              return value.diag != "W" && value.diag != "a" && value.diag != "b";
            });
            if (_anomaliesArray.length > 0) {
              markerIcon = L.divIcon({
                className: "",
                html: L.Util.template(
                  iconSettings.iconProbeAnomalies.mapIconUrl,
                  iconSettings.iconProbeAnomalies
                ),
                iconAnchor: [14, 38],
                iconSize: [30, 40],
              });
            }
          }

          if (data[_C_probeId].diag.probe_status == "maintenance") {
            markerIcon = L.divIcon({
              className: "",
              html: L.Util.template(
                iconSettings.iconProbeWarning.mapIconUrl,
                iconSettings.iconProbeWarning
              ),
              iconAnchor: [14, 38],
              iconSize: [30, 40],
            });
          }

          markersMap.push({
            ...data[_C_probeId],
            probeid: _C_probeId,
            icon: markerIcon,
          });
        });

      Object.keys(data)
        .filter((value) => {
          return (
            (data[value].diag.probe_status != "not_deployed" &&
              data[value].status == "KO") ||
            !isValidCoordinates(
              data[value].location.data.lat,
              data[value].location.data.long
            )
          );
        })
        .forEach((_C_probeId, _C_idx) => {
          markersError.push({
            ...data[_C_probeId],
            probeid: _C_probeId,
          });
        });
      this.setState({
        locations: markersMap,
        locationsErrData: markersError,
        isLocationsErr: markersError.length > 0,
        loading: false,
      });

      setTimeout(() => {
        let probeMapFocus =
          this.getAppContext().getLocalStorageService().get("probeMapFocus") ||
          this.props.probeMapFocus;
        this.getAppContext().getLocalStorageService().isSet("probeMapFocus") &&
          this.getAppContext().getLocalStorageService().remove("probeMapFocus");
        // &&
        // this.getAppContext()
        //   .getLocalStorageService()
        //   .set("dashboard_view_mode", "card");
        if (
          probeMapFocus &&
          markersMap.find((value) => {
            return value.probeid == probeMapFocus;
          }) &&
          markersError.find((value) => {
            return value.probeid == probeMapFocus;
          }) == undefined
        ) {
          let _focusMarker = this.state.locations.find((entry) => {
            return entry.probeid == probeMapFocus;
          });
          this.showZoomMarker(_focusMarker);
        } else if (
          probeMapFocus &&
          markersError.find((value) => {
            return value.probeid == probeMapFocus;
          }) != undefined
        ) {
          this.setState({ initFocus: probeMapFocus });
          this.showLocationErr(this.state.locationsErrData);
        }
      }, 600);
    } else {
      this._bounds = [[44.975893, 7.714009]];
      this.setState({
        locations: [],
        loading: false,
      });
    }
  }

  showLocationErr(data) {
    if (this._circleMap != null) {
      this.mapRef.leafletElement.removeLayer(this._circleMap);
      this._circleMap = null;
    }

    let errData = {
      offline: [],
      maintenance: [],
      anomalies: [],
      online: [],
    };

    let _measureCountWithAnomalies = 0;
    let _measureCountForProbe = 0;

    data.forEach((_marker, _id) => {
      if (_marker.diag.probe_status == "maintenance") {
        errData.maintenance.push(_marker);
      } else {
        if (_marker.diag.sync_status == 0) {
          errData.offline.push(_marker);
        } else {
          let anomaliesMeasures = _marker.diag.measures.filter((value) => {
            return value.diag != "W" && value.diag != "a" && value.diag != "b";
          });
          if (anomaliesMeasures.length > 0) {
            _measureCountWithAnomalies += anomaliesMeasures.length;
            _measureCountForProbe += _marker.diag.measures.length;
            errData.anomalies.push({ ..._marker, anomaliesMeasures: anomaliesMeasures });
          } else {
            errData.online.push(_marker);
          }
        }
      }
      errData = {
        ...errData,
        _measureCountWithAnomalies: _measureCountWithAnomalies,
        _measureCountForProbe: _measureCountForProbe,
      };
    });

    this.setState({
      selectedMarker: null,
      selectedItem: errData,
      showingErr: true,
      iconSelected: null,
    });
  }

  showCluster(cluster) {
    if (this._circleMap != null) {
      this.mapRef.leafletElement.removeLayer(this._circleMap);
      this._circleMap = null;
    }

    let clusterData = {
      offline: [],
      maintenance: [],
      anomalies: [],
      online: [],
    };

    let _measureCountWithAnomalies = 0;
    let _measureCountForProbe = 0;
    cluster.layer.getAllChildMarkers().forEach((a, b) => {
      if (a.options.dataMarker.diag.probe_status == "maintenance") {
        clusterData.maintenance.push(a.options.dataMarker);
      } else {
        if (a.options.dataMarker.diag.sync_status == 0) {
          clusterData.offline.push(a.options.dataMarker);
        } else {
          let anomaliesMeasures = a.options.dataMarker.diag.measures.filter((value) => {
            return value.diag != "W" && value.diag != "a" && value.diag != "b";
          });
          if (anomaliesMeasures.length > 0) {
            _measureCountWithAnomalies += anomaliesMeasures.length;
            _measureCountForProbe += a.options.dataMarker.diag.measures.length;
            clusterData.anomalies.push({
              ...a.options.dataMarker,
              anomaliesMeasures: anomaliesMeasures,
            });
          } else {
            clusterData.online.push(a.options.dataMarker);
          }
        }
      }
      clusterData = {
        ...clusterData,
        _measureCountWithAnomalies: _measureCountWithAnomalies,
        _measureCountForProbe: _measureCountForProbe,
        latlng: [cluster.latlng],
        zoom: this.mapRef.leafletElement.getZoom(),
      };
    });

    if (this.getAppContext().media.isMobile != true) {
      this.mapRef.leafletElement.fitBounds([cluster.latlng], {
        paddingBottomRight: [550, 30],
        maxZoom: this.mapRef.leafletElement.getZoom(),
      });
    }

    this.setState({
      selectedMarker: null,
      selectedItem: clusterData,
      iconSelected: null,
      initFocus: null,
      showingErr: null,
    });

    this._circleMap = L.circleMarker(cluster.layer.getLatLng(), {
      radius: 35,
      fillColor: "#3279B7",
      color: "#3279B7",
    });
    this.mapRef.leafletElement.addLayer(this._circleMap);
  }

  showMarker(marker) {
    if (this._circleMap != null) {
      this.mapRef.leafletElement.removeLayer(this._circleMap);
      this._circleMap = null;
    }
    let anomaliesCount = marker.diag.measures.filter((value) => {
      return value.diag != "W" && value.diag != "a" && value.diag != "b";
    });
    let workingMeasures = marker.diag.measures.filter((value) => {
      return value.diag == "W" || value.diag == "a" || value.diag == "b";
    });

    if (this.getAppContext().media.isMobile != true) {
      this.mapRef.leafletElement.fitBounds(
        [[marker.location.data.lat, marker.location.data.long]],
        { paddingBottomRight: [550, 30], maxZoom: this.mapRef.leafletElement.getZoom() }
      );
    }

    if (this.getAppContext().media.isMobile) {
      this.mapRef.leafletElement.fitBounds(
        [[marker.location.data.lat, marker.location.data.long]],
        { paddingBottomRight: [0, -50], maxZoom: this.mapRef.leafletElement.getZoom() }
      );
    }

    this.setState({
      selectedItem: null,
      showingErr: null,
      initFocus: null,
      idSelected: marker.probeid,
      selectedMarker: {
        ...marker,
        anomaliesMeasures: anomaliesCount,
        workingMeasures: workingMeasures,
        latlng: [marker.location.data.lat, marker.location.data.long],
        zoom: this.mapRef.leafletElement.getZoom(),
      },
    });

    this._circleMap = L.circleMarker(
      [marker.location.data.lat, marker.location.data.long],
      { radius: 20, fillColor: "#3279B7", color: "#3279B7" }
    );
    this.mapRef.leafletElement.addLayer(this._circleMap);
  }

  showZoomMarker(marker) {
    let anomaliesCount = marker.diag.measures.filter((value) => {
      return value.diag != "W" && value.diag != "a" && value.diag != "b";
    });
    let workingMeasures = marker.diag.measures.filter((value) => {
      return value.diag == "W" || value.diag == "a" || value.diag == "b";
    });
    this.mapRef.leafletElement.fitBounds(
      [[marker.location.data.lat, marker.location.data.long]],
      { paddingBottomRight: [550, 30], maxZoom: 19 }
    );

    this.setState({
      selectedItem: null,
      onFocus: true,
      idSelected: marker.probeid,
      selectedMarker: {
        ...marker,
        anomaliesMeasures: anomaliesCount,
        workingMeasures: workingMeasures,
        latlng: [marker.location.data.lat, marker.location.data.long],
        zoom: 19,
      },
    });

    this._circleMap = L.circleMarker(
      [marker.location.data.lat, marker.location.data.long],
      { radius: 20, fillColor: "#3279B7", color: "#3279B7" }
    );
    this.mapRef.leafletElement.addLayer(this._circleMap);
  }

  createClusterCustomIcon(cluster) {
    let reportCluster = {
      offline: 0,
      online: 0,
      anomalies: 0,
      maintenance: 0,
    };

    let offline = 0;
    let online = 0;
    let anomalies = 0;
    let maintenance = 0;

    let iconClass = "marker-cluster-green";

    cluster.getAllChildMarkers().forEach((_element) => {
      // console.log(_element)
      if (
        _element.options.dataMarker.diag.sync_status == 0 &&
        _element.options.dataMarker.diag.probe_status == "deployed"
      ) {
        reportCluster.offline += 1;
        offline = offline + 1;
      }

      if (_element.options.dataMarker.diag.probe_status == "maintenance") {
        reportCluster.maintenance += 1;
        maintenance = maintenance + 1;
      }

      if (
        _element.options.dataMarker.diag.sync_status == 1 &&
        _element.options.dataMarker.diag.probe_status == "deployed" &&
        _element.options.dataMarker.diag.measures.filter((value) => {
          return value.diag != "W" && value.diag != "a" && value.diag != "b";
        }).length > 0
      ) {
        reportCluster.anomalies += 1;
        anomalies = anomalies + 1;
      }

      if (
        _element.options.dataMarker.diag.sync_status == 1 &&
        _element.options.dataMarker.diag.probe_status == "deployed" &&
        _element.options.dataMarker.diag.measures.filter((value) => {
          return value.diag != "W" && value.diag != "a" && value.diag != "b";
        }).length == 0
      ) {
        reportCluster.online += 1;
        online = online + 1;
      }
    });

    if (
      (reportCluster.offline > 0 && reportCluster.online > 0) ||
      (reportCluster.offline > 0 && reportCluster.anomalies > 0)
    ) {
      iconClass = "marker-cluster-mix";
    }

    if (
      reportCluster.offline > 0 &&
      reportCluster.online == 0 &&
      reportCluster.anomalies == 0
    ) {
      iconClass = "marker-cluster-red";
    }

    if (
      reportCluster.offline == 0 &&
      reportCluster.online > 0 &&
      reportCluster.anomalies == 0
    ) {
      iconClass = "marker-cluster-green";
    }

    if (
      reportCluster.offline == 0 &&
      reportCluster.online == 0 &&
      reportCluster.anomalies > 0
    ) {
      iconClass = "marker-cluster-anomalies";
    }

    if (
      reportCluster.offline == 0 &&
      reportCluster.online > 0 &&
      reportCluster.anomalies > 0
    ) {
      iconClass = "marker-cluster-anomalies-mix";
    }

    if (
      reportCluster.maintenance > 0 &&
      reportCluster.offline == 0 &&
      reportCluster.online == 0 &&
      reportCluster.anomalies == 0
    ) {
      iconClass = "marker-cluster-anomalies-mix";
    }

    // let dataChart = [
    // {title: "Offline", value: offline, color: "#DC3545"},
    // {title: "Anomalies", value: anomalies, color: "#f5c6cb"},
    // {title: "Online", value: online, color: "#28A745"},
    // {title: "Maintenance", value: maintenance, color: "#FFC104"},
    // ]

    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: iconClass,
      iconSize: L.point(38, 38, true),
    });

    // return L.divIcon({
    // html: ReactDOMServer.renderToStaticMarkup(
    // <div>
    // 	<span className='marker-cluster-chart'>{cluster.getChildCount()}</span>
    // 	<ReactSvgPieChart
    // 	data={dataChart}
    // 	startAngle={135}
    // />
    // </div>
    // ),
    // className: ``,
    // iconSize: new L.Point(55, 55, true)
    // })
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <div>
        <Panel
          className={"rounded"}
          bodyClassName="p-0"
          header={
            <div className="d-flex flex-grow-1">
              <div className="flex-grow-1">PROBES LOCATIONS</div>
              {this.state.isLocationsErr && this.state.isLocationsErr == true ? (
                <div className="justify-content-end">
                  {!this.getAppContext().media.isMobile ? (
                    <span className="info-title mr-1">
                      {this.state.locationsErrData.length +
                        (this.state.locationsErrData.length == 1
                          ? " probe "
                          : " probes ")}{" "}
                      with unavailable location{" "}
                    </span>
                  ) : null}
                  <ReactOButton
                    icon="warning"
                    outline={!this.state.showingErr}
                    color={this.state.showingErr ? "primary" : "secondary"}
                    size="sm"
                    title="Warning"
                    onClick={() => {
                      this.showLocationErr(this.state.locationsErrData);
                      this.setState({ initFocus: null });
                    }}
                  />
                </div>
              ) : null}
            </div>
          }
        >
          <div className="position-relative">
            {/* SLECTED CLUSTER / WARNING */}
            {this.state.selectedItem ? (
              <div
                className={
                  this.getAppContext().media.isMobile
                    ? "position-absolute container-cluster-mobile mx-2"
                    : "position-absolute container-cluster mx-3"
                }
              >
                <div className="px-3 pt-3 pb-2 border-bottom border-3 border-primary mt-3 popup-top-bar text-light">
                  <div className="py-1">
                    <div xs={12} className="pr-1">
                      <Row
                        noGutters
                        style={
                          this.getAppContext().media.isMobile
                            ? { display: "block" }
                            : null
                        }
                      >
                        <div className="d-flex flex-grow-1">
                          <div className="flex-grow-1">
                            {this.state.showingErr ? (
                              <h4>
                                <strong>
                                  {this.state.locationsErrData.length} probe with
                                  unavailable location
                                </strong>
                              </h4>
                            ) : (
                              <h4>
                                <strong>
                                  {this.state.selectedItem.maintenance.length +
                                    this.state.selectedItem.offline.length +
                                    this.state.selectedItem.anomalies.length +
                                    this.state.selectedItem.online.length}{" "}
                                  probes
                                </strong>
                              </h4>
                            )}
                          </div>
                          <div className="justify-content-end">
                            {this.getAppContext().media.isMobile ||
                            this.state.showingErr ? (
                              <ReactOButton
                                icon="cancel"
                                size="sm"
                                title="Close"
                                onClick={() => {
                                  if (this._circleMap != null) {
                                    this.mapRef.leafletElement.removeLayer(
                                      this._circleMap
                                    );
                                    this._circleMap = null;
                                  }
                                  this.setState({
                                    selectedItem: null,
                                    selectedMarker: null,
                                    showingErr: null,
                                    onFocus: false,
                                    initFocus: null,
                                  });
                                }}
                              />
                            ) : (
                              <ReactOButton
                                icon="location"
                                size="sm"
                                title="Locate"
                                onClick={() => {
                                  this.mapRef.leafletElement.fitBounds(
                                    this.state.selectedItem.latlng,
                                    {
                                      paddingBottomRight: [550, 30],
                                      maxZoom: this.state.selectedItem.zoom,
                                    }
                                  );
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </div>
                </div>

                <Panel
                  className={
                    this.getAppContext().media.isMobile
                      ? "diag-map-cluster-mobile popup-top-bar text-light"
                      : this.state.showingErr
                      ? "diag-map-err popup-top-bar text-light pb-2"
                      : "diag-map-cluster popup-top-bar text-light"
                  }
                  bodyClassName="p-0"
                  noBorder
                >
                  {this.state.selectedItem.offline.length > 0 ? (
                    <div className="mt-3 px-3">
                      <div
                        className="diag-bg px-2"
                        onClick={() => {
                          this._advanced_collapse1.toggle();
                        }}
                      >
                        <div className="py-2">
                          <div xs={12}>
                            <Row
                              noGutters
                              style={
                                this.getAppContext().media.isMobile
                                  ? { display: "block" }
                                  : null
                              }
                            >
                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <strong>
                                    {this.state.selectedItem.offline.length} Offline
                                  </strong>
                                </div>
                                <div className="justify-content-end">
                                  <strong>
                                    {this.getAppContext().media.isMobile
                                      ? null
                                      : "Details "}
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened1 == false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                      </div>

                      <ReactOCollapse
                        className="border-top border-2"
                        onControllerReady={(_collapse_controller) => {
                          this._advanced_collapse1 = _collapse_controller;
                          this.setState({ _advanced_collapse_opened1: false });
                        }}
                        onOpened={() => {
                          this.setState({ _advanced_collapse_opened1: true });
                        }}
                        onClosed={() => {
                          this.setState({ _advanced_collapse_opened1: false });
                        }}
                        initOpen={this.state.selectedItem.offline.find((value) => {
                          return value.probeid == this.state.initFocus;
                        })}
                      >
                        <ReactOTable
                          thClassName="px-3 py-1 tableTh-black"
                          tdClassName="align-middle px-3 py-2 text-light"
                          hoverable
                          compressed={this.getAppContext().media.isMobile}
                          compressedDark
                          compressedRowRendering={(row_items) => {
                            return (
                              <div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.probe.content}
                                </div>
                                <div className="mt-2">{row_items.status.content}</div>
                              </div>
                            );
                          }}
                          thDividers
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "15",
                              sortable: true,
                            },
                            {
                              title: "STATUS",
                              align: "center",
                              data_key: "status",
                              width: "20",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let _TMP0 = [];

                            this.state.selectedItem.offline.forEach((_C_row0, C_id) => {
                              _TMP0.push({
                                // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                probe: {
                                  value: _C_row0.name,
                                  render: (
                                    <div>
                                      <Link
                                        to={"/" + _C_row0.probeid + "/active"}
                                        target="_blank"
                                      >
                                        <div>
                                          <strong> {_C_row0.name} </strong>
                                        </div>
                                        <div className="sub-title-light">
                                          {" "}
                                          {_C_row0.probeid
                                            .replace(/(..)/g, "$1:")
                                            .slice(0, -1)}{" "}
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                status: {
                                  value: "offline",
                                  render: (
                                    <Link
                                      to={"/" + _C_row0.probeid + "/active"}
                                      target="_blank"
                                    >
                                      <strong className="text-danger">Offline</strong>
                                    </Link>
                                  ),
                                },
                              });
                            });
                            return _TMP0;
                          })()}
                        ></ReactOTable>
                      </ReactOCollapse>
                    </div>
                  ) : null}

                  {this.state.selectedItem.anomalies.length > 0 ? (
                    <div className="mt-3 px-3">
                      <div
                        className="diag-bg px-2"
                        onClick={() => {
                          this._advanced_collapse2.toggle();
                        }}
                      >
                        <div className="py-2">
                          <div xs={12}>
                            <Row
                              noGutters
                              style={
                                this.getAppContext().media.isMobile
                                  ? { display: "block" }
                                  : null
                              }
                            >
                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <strong>
                                    {this.state.selectedItem.anomalies.length} Online,{" "}
                                    {this.state.selectedItem._measureCountWithAnomalies}/
                                    {this.state.selectedItem._measureCountForProbe}{" "}
                                    measures with anomalies
                                  </strong>
                                </div>
                                <div className="justify-content-end">
                                  <strong>
                                    {this.getAppContext().media.isMobile
                                      ? null
                                      : "Details "}
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened2 == false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                      </div>

                      <ReactOCollapse
                        className="border-top border-2"
                        onControllerReady={(_collapse_controller) => {
                          this._advanced_collapse2 = _collapse_controller;
                          this.setState({ _advanced_collapse_opened2: false });
                        }}
                        onOpened={() => {
                          this.setState({ _advanced_collapse_opened2: true });
                        }}
                        onClosed={() => {
                          this.setState({ _advanced_collapse_opened2: false });
                        }}
                        initOpen={this.state.selectedItem.anomalies.find((value) => {
                          return value.probeid == this.state.initFocus;
                        })}
                      >
                        <ReactOTable
                          thClassName="px-3 py-1"
                          tdClassName="align-middle px-3 py-2 text-light"
                          hoverable
                          compressedDark
                          compressed={this.getAppContext().media.isMobile}
                          compressedRowRendering={(row_items) => {
                            return (
                              <div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.probe.content}
                                </div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.measure.content}
                                </div>
                              </div>
                            );
                          }}
                          thDividers
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "15",
                              sortable: true,
                            },
                            {
                              title: "MEASURE",
                              align: "center",
                              data_key: "measure",
                              width: "20",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let _TMP0 = [];

                            this.state.selectedItem.anomalies.forEach((_C_row0, C_id) => {
                              _TMP0.push({
                                // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                probe: {
                                  value: _C_row0.name,
                                  render: (
                                    <div>
                                      <Link
                                        to={"/" + _C_row0.probeid + "/active"}
                                        target="_blank"
                                      >
                                        <div>
                                          <strong> {_C_row0.name} </strong>
                                        </div>
                                        <div className="sub-title-light">
                                          {" "}
                                          {_C_row0.probeid
                                            .replace(/(..)/g, "$1:")
                                            .slice(0, -1)}{" "}
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                measure: {
                                  value: _C_row0.diag.measures.length,
                                  render: (
                                    <div>
                                      <Link
                                        to={"/" + _C_row0.probeid + "/active"}
                                        target="_blank"
                                      >
                                        {_C_row0.anomaliesMeasures.length} measures with
                                        anomalies
                                        <div className="sub-title-light">
                                          ({_C_row0.diag.measures.length} total mesures)
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                              });
                            });
                            return _TMP0;
                          })()}
                        ></ReactOTable>
                      </ReactOCollapse>
                    </div>
                  ) : null}

                  {this.state.selectedItem.maintenance.length > 0 ? (
                    <div className="mt-3 px-3">
                      <div
                        className="maintenance-bg px-2"
                        onClick={() => {
                          this._advanced_collapse4.toggle();
                        }}
                      >
                        <div className="py-2">
                          <div xs={12}>
                            <Row
                              noGutters
                              style={
                                this.getAppContext().media.isMobile
                                  ? { display: "block" }
                                  : null
                              }
                            >
                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <strong>
                                    {this.state.selectedItem.maintenance.length} in
                                    Maintenance
                                  </strong>
                                </div>
                                <div className="justify-content-end">
                                  <strong>
                                    {this.getAppContext().media.isMobile
                                      ? null
                                      : "Details "}
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened4 == false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                      </div>

                      <ReactOCollapse
                        className="border-top border-2 border-warningr"
                        onControllerReady={(_collapse_controller) => {
                          this._advanced_collapse4 = _collapse_controller;
                          this.setState({ _advanced_collapse_opened4: false });
                        }}
                        onOpened={() => {
                          this.setState({ _advanced_collapse_opened4: true });
                        }}
                        onClosed={() => {
                          this.setState({ _advanced_collapse_opened4: false });
                        }}
                        initOpen={this.state.selectedItem.maintenance.find((value) => {
                          return value.probeid == this.state.initFocus;
                        })}
                      >
                        <ReactOTable
                          thClassName="px-3 py-1"
                          tdClassName="align-middle px-3 py-2 text-light"
                          hoverable
                          compressedDark
                          compressed={this.getAppContext().media.isMobile}
                          compressedRowRendering={(row_items) => {
                            return (
                              <div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.probe.content}
                                </div>
                                <div className="mt-2">{row_items.status.content}</div>
                              </div>
                            );
                          }}
                          thDividers
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "15",
                              sortable: true,
                            },
                            {
                              title: "MEASURE",
                              align: "center",
                              data_key: "status",
                              width: "20",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let _TMP0 = [];

                            this.state.selectedItem.maintenance.forEach(
                              (_C_row0, C_id) => {
                                _TMP0.push({
                                  // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                  probe: {
                                    value: _C_row0.name,
                                    render: (
                                      <div>
                                        <Link
                                          to={"/" + _C_row0.probeid + "/active"}
                                          target="_blank"
                                        >
                                          <div>
                                            <strong> {_C_row0.name} </strong>
                                          </div>
                                          <div className="sub-title-light">
                                            {" "}
                                            {_C_row0.probeid
                                              .replace(/(..)/g, "$1:")
                                              .slice(0, -1)}{" "}
                                          </div>
                                        </Link>
                                      </div>
                                    ),
                                  },
                                  status: {
                                    value: _C_row0.diag.sync_status,
                                    render: (
                                      <div>
                                        <Link
                                          to={"/" + _C_row0.probeid + "/active"}
                                          target="_blank"
                                        >
                                          {_C_row0.diag.sync_status == 0 ? (
                                            <strong className="text-danger">
                                              Offline
                                            </strong>
                                          ) : (
                                            <strong className="text-success">
                                              Online
                                            </strong>
                                          )}
                                        </Link>
                                      </div>
                                    ),
                                  },
                                });
                              }
                            );
                            return _TMP0;
                          })()}
                        ></ReactOTable>
                      </ReactOCollapse>
                    </div>
                  ) : null}

                  {this.state.selectedItem.online.length > 0 ? (
                    <div className="mt-3 px-3">
                      <div
                        className="working-bg px-2"
                        onClick={() => {
                          this._advanced_collapse3.toggle();
                        }}
                      >
                        <div className="py-2">
                          <div xs={12}>
                            <Row
                              noGutters
                              style={
                                this.getAppContext().media.isMobile
                                  ? { display: "block" }
                                  : null
                              }
                            >
                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <strong>
                                    {this.state.selectedItem.online.length} Online
                                  </strong>
                                </div>
                                <div className="justify-content-end">
                                  <strong>
                                    {this.getAppContext().media.isMobile
                                      ? null
                                      : "Details "}
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened3 == false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              </div>
                            </Row>
                          </div>
                        </div>
                      </div>

                      <ReactOCollapse
                        className="border-top border-2"
                        onControllerReady={(_collapse_controller) => {
                          this._advanced_collapse3 = _collapse_controller;
                          this.setState({ _advanced_collapse_opened3: false });
                        }}
                        onOpened={() => {
                          this.setState({ _advanced_collapse_opened3: true });
                        }}
                        onClosed={() => {
                          this.setState({ _advanced_collapse_opened3: false });
                        }}
                        initOpen={this.state.selectedItem.online.find((value) => {
                          return value.probeid == this.state.initFocus;
                        })}
                      >
                        <ReactOTable
                          thClassName="px-3 py-1"
                          tdClassName="align-middle px-3 py-2 text-light"
                          hoverable
                          compressedDark
                          compressed={this.getAppContext().media.isMobile}
                          compressedRowRendering={(row_items) => {
                            return (
                              <div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.probe.content}
                                </div>
                                <div className="mt-2" style={{ color: "white" }}>
                                  {row_items.measure.content}
                                </div>
                              </div>
                            );
                          }}
                          thDividers
                          cols={[
                            {
                              title: "PROBE",
                              align: "center",
                              data_key: "probe",
                              width: "15",
                              sortable: true,
                            },
                            {
                              title: "MEASURE",
                              align: "center",
                              data_key: "measure",
                              width: "20",
                              sortable: true,
                            },
                          ]}
                          rows={(() => {
                            let _TMP0 = [];

                            this.state.selectedItem.online.forEach((_C_row0, C_id) => {
                              _TMP0.push({
                                // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                probe: {
                                  value: _C_row0.name,
                                  render: (
                                    <div>
                                      <Link
                                        to={"/" + _C_row0.probeid + "/active"}
                                        target="_blank"
                                      >
                                        <div>
                                          <strong> {_C_row0.name} </strong>
                                        </div>
                                        <div className="sub-title-light">
                                          {" "}
                                          {_C_row0.probeid
                                            .replace(/(..)/g, "$1:")
                                            .slice(0, -1)}{" "}
                                        </div>
                                      </Link>
                                    </div>
                                  ),
                                },
                                measure: {
                                  value: _C_row0.diag.measures.length,
                                  render: (
                                    <Link
                                      to={"/" + _C_row0.probeid + "/active"}
                                      target="_blank"
                                    >
                                      <span>
                                        {_C_row0.diag.measures.length} working measures
                                      </span>
                                    </Link>
                                  ),
                                },
                              });
                            });
                            return _TMP0;
                          })()}
                        ></ReactOTable>
                      </ReactOCollapse>
                    </div>
                  ) : null}
                </Panel>
              </div>
            ) : null}

            {/* SELECT MARKER */}
            {this.state.selectedMarker ? (
              <div
                className={
                  this.getAppContext().media.isMobile
                    ? "position-absolute container-marker-mobile mx-2"
                    : "position-absolute container-marker mx-3"
                }
              >
                <div className="px-3 pt-3 pb-2 border-bottom border-3 border-primary mt-3 popup-top-bar text-light">
                  <div className="py-1">
                    <div xs={12} className="pr-1">
                      <Row
                        noGutters
                        style={
                          this.getAppContext().media.isMobile
                            ? { display: "block" }
                            : null
                        }
                      >
                        <div className="d-flex flex-grow-1">
                          <div className="flex-grow-1">
                            <Link
                              className="no-link-style"
                              to={"/" + this.state.selectedMarker.probeid + "/active"}
                              target="_blank"
                            >
                              <h4>
                                {this.state.selectedMarker.name
                                  ? this.state.selectedMarker.name.slice(0, 37)
                                  : "-"}
                              </h4>
                              {this.state.selectedMarker.probeid
                                ? this.state.selectedMarker.probeid
                                    .replace(/(..)/g, "$1:")
                                    .slice(0, -1)
                                : "-"}
                              {/* {this.state.selectedMarker.location.personalized == 'yes' ? <span>{'\u00A0'}{'\u00A0'}(personalized position)</span> :null} */}
                              {this.state.selectedMarker.location.old ? (
                                <span>
                                  {"\u00A0"}
                                  {"\u00A0"}(last location update:{" "}
                                  {this.getAppContext()
                                    .momentjs(this.state.selectedMarker.location.old, "X")
                                    .format("L")}{" "}
                                  )
                                </span>
                              ) : this.state.selectedMarker.location.personalized ==
                                "yes" ? (
                                <span>
                                  {"\u00A0"}
                                  {"\u00A0"}(explicit position)
                                </span>
                              ) : null}
                            </Link>
                          </div>
                          <div className="justify-content-end">
                            {this.getAppContext().media.isMobile ? (
                              <ReactOButton
                                icon="cancel"
                                size="sm"
                                title="Close"
                                onClick={() => {
                                  this.mapRef.leafletElement.removeLayer(this._circleMap);
                                  this._circleMap = null;
                                  this.setState({
                                    selectedItem: null,
                                    selectedMarker: null,
                                    onFocus: false,
                                  });
                                }}
                              />
                            ) : (
                              <ReactOButton
                                icon="location"
                                size="sm"
                                title="Locate"
                                onClick={() => {
                                  this.mapRef.leafletElement.fitBounds(
                                    [this.state.selectedMarker.latlng],
                                    {
                                      paddingBottomRight: [550, 30],
                                      maxZoom: this.state.selectedMarker.zoom,
                                    }
                                  );
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </Row>
                    </div>
                  </div>
                </div>

                <Panel
                  noBorder
                  className={
                    this.getAppContext().media.isMobile
                      ? "diag-map-marker-mobile popup-top-bar text-light"
                      : "diag-map-marker popup-top-bar text-light"
                  }
                  bodyClassName="p-0"
                  style={
                    this.state.selectedMarker.diag.sync_status == 0 ||
                    this.state.selectedMarker.diag.probe_status == "maintenance"
                      ? null
                      : this.getAppContext().media.isMobile
                      ? { height: "540px" }
                      : { height: "580px" }
                  }
                >
                  {/* SELECT MARKER -- OFFLINE */}
                  {this.state.selectedMarker.diag.sync_status == 0 &&
                  this.state.selectedMarker.diag.probe_status != "maintenance" ? (
                    <Section
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={1}
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray600}
                    >
                      <div className="d-flex flex-column p-2">
                        <div className="text-gray400 ml-1">
                          <strong>SYNC STATUS</strong>
                        </div>
                        <strong className="d-flex h-100 align-items-start text-light">
                          <span className="text-danger ml-1">Offline</span>
                        </strong>
                      </div>
                      <div className="d-flex flex-column p-2">
                        <div className="text-gray400 ml-1">
                          <strong>SINCE</strong>
                        </div>
                        <strong className="d-flex h-100 align-items-start text-light">
                          <span className="ml-1">
                            {" "}
                            {this.state.selectedMarker.diag.sync_status_ts
                              ? this.getAppContext()
                                  .momentjs(
                                    this.state.selectedMarker.diag.sync_status_ts,
                                    "X"
                                  )
                                  .format("L LT")
                              : "-"}{" "}
                          </span>
                        </strong>
                      </div>
                    </Section>
                  ) : null}

                  {/* SELECT MARKER -- MAINTENACE */}
                  {this.state.selectedMarker.diag.probe_status == "maintenance" ? (
                    <Section
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={1}
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray600}
                    >
                      <div className="d-flex flex-column p-2 ml-1">
                        <div className="text-gray400">
                          <strong>PROBE STATUS</strong>
                        </div>
                        <strong className="d-flex h-100 align-items-start text-light">
                          <span>Mintenance</span>
                        </strong>
                      </div>
                      <div className="d-flex flex-column p-2 ml-1">
                        <div className="text-gray400">
                          <strong>SYNC STATUS</strong>
                        </div>
                        <strong className="d-flex h-100 align-items-start text-light">
                          <span className="text-danger">Offline</span>
                        </strong>
                      </div>
                      <div className="d-flex flex-column p-2 ml-1">
                        <div className="text-gray400">
                          <strong>SINCE</strong>
                        </div>
                        <strong className="d-flex h-100 align-items-start text-light">
                          <span>
                            {" "}
                            {this.state.selectedMarker.diag.sync_status_ts
                              ? this.getAppContext()
                                  .momentjs(
                                    this.state.selectedMarker.diag.sync_status_ts,
                                    "X"
                                  )
                                  .format("L LT")
                              : "-"}{" "}
                          </span>
                        </strong>
                      </div>
                    </Section>
                  ) : null}

                  {/* SELECT MARKER -- ONLINE */}
                  {this.state.selectedMarker.diag.sync_status == 1 &&
                  this.state.selectedMarker.diag.probe_status != "maintenance" ? (
                    <Section
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={1}
                      gridSpacing={1}
                      // gridSpacingColor={this.getAppContext().colors.gray600}
                    >
                      {this.state.selectedMarker.anomaliesMeasures.length > 0 ? (
                        <div className="mt-3 px-3">
                          <div
                            className="diag-bg px-2"
                            onClick={() => {
                              this._advanced_collapse6.toggle();
                            }}
                          >
                            <div className="py-2">
                              <div xs={12}>
                                <Row
                                  noGutters
                                  style={
                                    this.getAppContext().media.isMobile
                                      ? { display: "block" }
                                      : null
                                  }
                                >
                                  <div className="d-flex flex-grow-1">
                                    <div className="flex-grow-1">
                                      <strong>
                                        {
                                          this.state.selectedMarker.anomaliesMeasures
                                            .length
                                        }{" "}
                                        measures with anomalies
                                      </strong>
                                    </div>
                                    <div className="justify-content-end">
                                      <strong>
                                        {this.getAppContext().media.isMobile
                                          ? null
                                          : "Details "}
                                        <span
                                          className={
                                            this.state._advanced_collapse_opened6 == false
                                              ? "icon-caret-down-outline"
                                              : "icon-caret-up-outline"
                                          }
                                        ></span>
                                      </strong>
                                    </div>
                                  </div>
                                </Row>
                              </div>
                            </div>
                          </div>

                          <ReactOCollapse
                            className="border-top border-2"
                            onControllerReady={(_collapse_controller) => {
                              this._advanced_collapse6 = _collapse_controller;
                              this.setState({ _advanced_collapse_opened6: false });
                            }}
                            onOpened={() => {
                              this.setState({ _advanced_collapse_opened6: true });
                            }}
                            onClosed={() => {
                              this.setState({ _advanced_collapse_opened6: false });
                            }}
                          >
                            <ReactOTable
                              thClassName="px-3 py-1"
                              tdClassName="align-middle px-3 py-2 text-light"
                              hoverable
                              compressedDark
                              compressed={this.getAppContext().media.isMobile}
                              compressedRowRendering={(row_items) => {
                                return (
                                  <div>
                                    <div className="mt-2" style={{ color: "white" }}>
                                      <strong>{row_items.measure.content}</strong>
                                    </div>
                                    <div className="mt-2" style={{ color: "white" }}>
                                      {row_items.bssid.content}
                                    </div>
                                    <div className="mt-2" style={{ color: "white" }}>
                                      {row_items.status.content}
                                    </div>
                                  </div>
                                );
                              }}
                              thDividers
                              cols={[
                                {
                                  title: "MEASURE",
                                  align: "center",
                                  data_key: "measure",
                                  width: "30",
                                  sortable: true,
                                },
                                {
                                  title: "BSSID",
                                  align: "center",
                                  data_key: "bssid",
                                  width: "38",
                                  sortable: true,
                                },
                                {
                                  title: "STATUS",
                                  align: "center",
                                  data_key: "status",
                                  width: "20",
                                  sortable: true,
                                },
                              ]}
                              rows={(() => {
                                let _TMP0 = [];

                                this.state.selectedMarker.anomaliesMeasures.forEach(
                                  (_C_row0, C_id) => {
                                    _TMP0.push({
                                      // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                      measure: {
                                        value: _C_row0.name,
                                        render: (
                                          <Link
                                            to={
                                              "/" +
                                              _C_row0.probeid +
                                              "/active/" +
                                              _C_row0.cssid +
                                              "/" +
                                              _C_row0.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <span> {_C_row0.name} </span>
                                          </Link>
                                        ),
                                      },
                                      bssid: {
                                        value: _C_row0.bssid,
                                        render: (
                                          <div>
                                            <Link
                                              to={
                                                "/" +
                                                _C_row0.probeid +
                                                "/active/" +
                                                _C_row0.cssid +
                                                "/" +
                                                _C_row0.bssid.replace(/:/g, "")
                                              }
                                              target="_blank"
                                            >
                                              {_C_row0.ap_name != "-" &&
                                              _C_row0.ap_name != _C_row0.bssid ? (
                                                <div>
                                                  <div> {_C_row0.ap_name} </div>
                                                  <div> {_C_row0.bssid} </div>
                                                </div>
                                              ) : (
                                                <div>
                                                  <div> {_C_row0.bssid} </div>
                                                  {_C_row0.manuf ? (
                                                    <div>{_C_row0.manuf}</div>
                                                  ) : null}
                                                </div>
                                              )}
                                            </Link>
                                          </div>
                                        ),
                                      },
                                      status: {
                                        value: _C_row0.diag,
                                        render: (
                                          <Link
                                            to={
                                              "/" +
                                              _C_row0.probeid +
                                              "/active/" +
                                              _C_row0.cssid +
                                              "/" +
                                              _C_row0.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <span
                                              className={
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[_C_row0.diag]
                                                  .color != "gray600"
                                                  ? "text-" +
                                                    this.getAppContext().conf
                                                      .MLY_STATES_DICTIONARY[_C_row0.diag]
                                                      .color
                                                  : null
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[_C_row0.diag]
                                                  .text
                                              }
                                            </span>
                                          </Link>
                                        ),
                                      },
                                    });
                                  }
                                );
                                return _TMP0;
                              })()}
                            ></ReactOTable>
                          </ReactOCollapse>
                        </div>
                      ) : null}

                      {this.state.selectedMarker.workingMeasures.length > 0 ? (
                        <div className="mt-3 px-3">
                          <div
                            className="working-bg px-2"
                            onClick={() => {
                              this._advanced_collapse7.toggle();
                            }}
                          >
                            <div className="py-2">
                              <div xs={12}>
                                <Row
                                  noGutters
                                  style={
                                    this.getAppContext().media.isMobile
                                      ? { display: "block" }
                                      : null
                                  }
                                >
                                  <div className="d-flex flex-grow-1">
                                    <div className="flex-grow-1">
                                      <strong>
                                        {this.state.selectedMarker.workingMeasures.length}
                                        {this.state.selectedMarker.workingMeasures
                                          .length == 1
                                          ? " working measure"
                                          : " working measures"}
                                      </strong>
                                    </div>
                                    <div className="justify-content-end">
                                      <strong>
                                        {this.getAppContext().media.isMobile
                                          ? null
                                          : "Details "}
                                        <span
                                          className={
                                            this.state._advanced_collapse_opened7 == false
                                              ? "icon-caret-down-outline"
                                              : "icon-caret-up-outline"
                                          }
                                        ></span>
                                      </strong>
                                    </div>
                                  </div>
                                </Row>
                              </div>
                            </div>
                          </div>

                          <ReactOCollapse
                            className="border-top border-2"
                            onControllerReady={(_collapse_controller) => {
                              this._advanced_collapse7 = _collapse_controller;
                              this.setState({ _advanced_collapse_opened7: false });
                            }}
                            onOpened={() => {
                              this.setState({ _advanced_collapse_opened7: true });
                            }}
                            onClosed={() => {
                              this.setState({ _advanced_collapse_opened7: false });
                            }}
                          >
                            <ReactOTable
                              thClassName="px-3 py-1"
                              tdClassName="align-middle px-3 py-2 text-light"
                              hoverable
                              compressedDark
                              compressed={this.getAppContext().media.isMobile}
                              compressedRowRendering={(row_items) => {
                                return (
                                  <div>
                                    <div className="mt-2" style={{ color: "white" }}>
                                      <strong>{row_items.measure.content}</strong>
                                    </div>
                                    <div className="mt-2" style={{ color: "white" }}>
                                      {row_items.bssid.content}
                                    </div>
                                    <div className="mt-2">{row_items.status.content}</div>
                                  </div>
                                );
                              }}
                              thDividers
                              cols={[
                                {
                                  title: "MEASURE",
                                  align: "center",
                                  data_key: "measure",
                                  width: "30",
                                  sortable: true,
                                },
                                {
                                  title: "BSSID",
                                  align: "center",
                                  data_key: "bssid",
                                  width: "38",
                                  sortable: true,
                                },
                                {
                                  title: "STATUS",
                                  align: "center",
                                  data_key: "status",
                                  width: "20",
                                  sortable: true,
                                },
                              ]}
                              rows={(() => {
                                let _TMP0 = [];

                                this.state.selectedMarker.workingMeasures.forEach(
                                  (_C_row0, C_id) => {
                                    _TMP0.push({
                                      // _link: '/' + _C_row0.probeid + '/active/' + _C_row0.cssid + '/' + _C_row0.bssid.replace(/:/g, ''),
                                      measure: {
                                        value: _C_row0.name,
                                        render: (
                                          <Link
                                            to={
                                              "/" +
                                              _C_row0.probeid +
                                              "/active/" +
                                              _C_row0.cssid +
                                              "/" +
                                              _C_row0.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <span> {_C_row0.name} </span>
                                          </Link>
                                        ),
                                      },
                                      bssid: {
                                        value: _C_row0.bssid,
                                        render: (
                                          <div>
                                            <Link
                                              to={
                                                "/" +
                                                _C_row0.probeid +
                                                "/active/" +
                                                _C_row0.cssid +
                                                "/" +
                                                _C_row0.bssid.replace(/:/g, "")
                                              }
                                              target="_blank"
                                            >
                                              {_C_row0.ap_name != "-" &&
                                              _C_row0.ap_name != _C_row0.bssid ? (
                                                <div>
                                                  <div> {_C_row0.ap_name} </div>
                                                  <div> {_C_row0.bssid} </div>
                                                </div>
                                              ) : (
                                                <div>
                                                  <div> {_C_row0.bssid} </div>
                                                  {_C_row0.manuf ? (
                                                    <div>{_C_row0.manuf}</div>
                                                  ) : null}
                                                </div>
                                              )}
                                            </Link>
                                          </div>
                                        ),
                                      },
                                      status: {
                                        value: _C_row0.diag,
                                        render: (
                                          <Link
                                            to={
                                              "/" +
                                              _C_row0.probeid +
                                              "/active/" +
                                              _C_row0.cssid +
                                              "/" +
                                              _C_row0.bssid.replace(/:/g, "")
                                            }
                                            target="_blank"
                                          >
                                            <span
                                              className={
                                                "text-" +
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[_C_row0.diag]
                                                  .color
                                              }
                                            >
                                              {
                                                this.getAppContext().conf
                                                  .MLY_STATES_DICTIONARY[_C_row0.diag]
                                                  .text
                                              }
                                            </span>
                                          </Link>
                                        ),
                                      },
                                      // since: {
                                      // 	value: _C_row0.since,
                                      // 	render: <span>{parseInt(_C_row0.since.match(/([0-9]){4}/g)) < 2014 ? '-' : _C_row0.since}</span> // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                                      // }
                                      // last: {
                                      // 	value: _C_row0.last_check,
                                      // 	render: <span>{parseInt(_C_row0.last_check.match(/([0-9]){4}/g)) < 2014 ? '-' : _C_row0.last_check}</span> // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                                      // }
                                    });
                                  }
                                );
                                return _TMP0;
                              })()}
                            ></ReactOTable>
                          </ReactOCollapse>

                          {this.state.selectedMarker.anomaliesMeasures.length == 0 ? (
                            <div className="py-3">
                              <strong>No measures with anomalies</strong>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </Section>
                  ) : null}
                </Panel>

                <div className="d-flex">
                  {this.getAppContext().authHandler.getAccountData().type == "ADMIN" ? (
                    <ReactOActionBar
                      className="bg-gray800" // p-3 border-bottom border-3 border-gray300
                      align="left"
                    >
                      <Link
                        to={"/" + this.state.selectedMarker.probeid + "/setup/general"}
                        target="_blank"
                        style={{
                          textDecoration: "none",
                        }}
                      >
                        <ReactOButton color="light" icon="settings" size="sm" />
                      </Link>
                      <Link
                        to={"/" + this.state.selectedMarker.probeid + "/config"}
                        target="_blank"
                        style={{
                          textDecoration: "none",
                        }}
                      >
                        <ReactOButton color="light" icon="pencil" size="sm" />
                      </Link>
                    </ReactOActionBar>
                  ) : null}

                  <ReactOActionBar
                    className="bg-gray800" // p-3 border-bottom border-3 border-gray300
                    align="right"
                  >
                    <Link
                      to={"/" + this.state.selectedMarker.probeid + "/active"}
                      target="_blank"
                      style={{
                        textDecoration: "none",
                        color: this.getAppContext().colors.primary,
                      }}
                    >
                      <ReactOButton color="primary" icon="arrow-next" iconRight size="sm">
                        View
                      </ReactOButton>
                    </Link>
                  </ReactOActionBar>
                </div>
              </div>
            ) : null}
          </div>
          <_LoadingWrapper
            loadingPlug={this.state.loading}
            hideOnLoading={true}
            minHeight
          >
            {this.state &&
            (this.state.controlMap == true || this.state.controlMap == false) &&
            this.state.locations.length > 0 ? (
              <div>
                <Map
                  ref={(ref) => {
                    this.mapRef = ref;
                  }}
                  style={{ height: "750px", backgroundColor: "#E6E4E0" }}
                  zoomControl={!this.getAppContext().media.isMobile}
                  attributionControl={false}
                  // center={this.state.center}
                  zoom={this.state.zoom}
                  maxZoom={19}
                  useFlyTo={true}
                  animate={true}
                  onzoomstart={() => {
                    if (this._circleMap != null && this.state.onFocus == false) {
                      this.mapRef.leafletElement.removeLayer(this._circleMap);
                      this._circleMap = null;
                      this.setState({
                        selectedItem: null,
                        selectedMarker: null,
                        initFocus: null,
                      });
                    } else if (this.state.showingErr) {
                      this.setState({
                        selectedItem: null,
                        selectedMarker: null,
                        showingErr: null,
                      });
                    }

                    this.setState({
                      onFocus: false,
                    });
                  }}
                  bounds={this._bounds}
                  boundsOptions={this.state.boundsOptions}
                  onClick={() => {
                    if (this._circleMap != null) {
                      this.mapRef.leafletElement.removeLayer(this._circleMap);
                      this._circleMap = null;
                      this.setState({
                        selectedItem: null,
                        selectedMarker: null,
                        showingErr: null,
                      });
                    } else {
                      this.setState({
                        selectedItem: null,
                        selectedMarker: null,
                        showingErr: null,
                      });
                    }
                  }}
                  // onzoomend={()=>{console.log("KKK " + this.mapRef.leafletElement.getZoom())}}
                >
                  <TileLayer
                    // url="https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=JYHMNjynotIPdtbXbWHS"
                    // url="https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoib3Jpb25saWdodDIzMSIsImEiOiJjazVmNzRyNTYwMHllM21wYXd3eXhvcXAxIn0.PT216Kt_-ceNLWsmsikTug"
                    // url="https://api.mapbox.com/styles/v1/orionlight231/ck5i1rv770mpb1imuw4pnot5p/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoib3Jpb25saWdodDIzMSIsImEiOiJjazVmNzRyNTYwMHllM21wYXd3eXhvcXAxIn0.PT216Kt_-ceNLWsmsikTug"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  />

                  {this.state.locations_data && this.state.locations ? (
                    <MarkerClusterGroup
                      ref={(ref) => {
                        this.clusterRef = ref;
                      }}
                      disableClusteringAtZoom={19}
                      showCoverageOnHover={false}
                      iconCreateFunction={this.createClusterCustomIcon}
                      zoomToBoundsOnClick={false}
                      spiderfyOnMaxZoom={false}
                      maxClusterRadius={90}
                      onClusterClick={(cluster) => {
                        if (this.state.controlMap != false) {
                          this.showCluster(cluster);
                        }
                      }}
                    >
                      {Object.values(this.state.locations).map((marker, id) => (
                        // console.log("aa " + JSON.stringify(marker))
                        <Marker
                          ref={(ref) => {
                            this.markerRef = ref;
                          }}
                          key={id}
                          position={[marker.location.data.lat, marker.location.data.long]}
                          icon={marker.icon}
                          dataMarker={marker}
                          onClick={(e) => {
                            // leafletElement.bindPopup('popup content').openPopup()
                            this.showMarker(e.target.options.dataMarker);
                          }}
                        ></Marker>
                      ))}
                    </MarkerClusterGroup>
                  ) : null}
                  {/* <MapCacheLayer />  */}
                </Map>

                {/* legenda */}
                <div className="border-top border-3 border-primary p-2">
                  <Row>
                    <Col className="ml-1">
                      {" "}
                      <strong>Probe Groups:</strong>{" "}
                    </Col>
                  </Row>
                  <Row className="mt-1 p-1">
                    <Col xs={12} md="auto">
                      <Row noGutters>
                        <div>
                          <span className="dot-red"></span>
                        </div>
                        <div>
                          <span className="pl-1">All Offline</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters style={{ flexWrap: "nowrap" }}>
                        <div>
                          <span className="dot-green"></span>
                        </div>
                        <div>
                          <span className="pl-1">All Online and Working</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters>
                        <div>
                          <span className="dot-red-green"></span>
                        </div>
                        <div>
                          <span className="pl-1">Some Online, some Offline</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters>
                        <div>
                          <span className="dot-anomalies"></span>
                        </div>
                        <div>
                          <span className="pl-1">All Online, some Anomalies</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters>
                        <div>
                          <span className="dot-anomalies-all"></span>
                        </div>
                        <div>
                          <span className="pl-1">All Online with Anomalies</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters>
                        <div>
                          <span className="dot-maintenance"></span>
                        </div>
                        <div>
                          <span className="pl-1">All in Maintenance</span>
                        </div>
                      </Row>
                    </Col>
                  </Row>

                  <Row>
                    {" "}
                    <Col className="ml-1">
                      {" "}
                      <strong>Probes:</strong>{" "}
                    </Col>{" "}
                  </Row>
                  <Row className="mt-1 p-1">
                    <Col xs={12} md="auto">
                      <Row noGutters className="pb-1">
                        <div>
                          <span>{iconProbeRed}</span>
                        </div>
                        <div>
                          <span className="pl-2">Offline</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters className="pb-1">
                        <div>
                          <span>{iconProbeGreen}</span>
                        </div>
                        <div>
                          <span className="pl-2">Online</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters className="pb-1">
                        <div>
                          <span>{iconProbeAnomalies}</span>
                        </div>
                        <div>
                          <span className="pl-2">Online with Anomalies</span>
                        </div>
                      </Row>
                    </Col>

                    <Col xs={12} md="auto">
                      <Row noGutters className="pb-1">
                        <div>
                          <span>{iconProbeWarning}</span>
                        </div>
                        <div>
                          <span className="pl-2">In Maintenance</span>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
            ) : (
              <div className="pl-2 pt-2">No probes with locations info.</div>
            )}
          </_LoadingWrapper>
        </Panel>
      </div>
    );
  }
}

export default contextProvider(
  //	Sites,
  withDefinedContext(Dashboard, "Dashboard"),
  {
    retrieve: ["_LayoutSidebar"],
  }
);
